module.exports = require("@google-cloud/dialogflow");